export default __webpack_public_path__ + "static/media/Etape10_Maraichere_After_Filtre.3bb4130f.jpg";